export * from './types'
export { DatesService } from './dates.service'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarComponent } from './calendar/calendar.component'
import { CalendarMonthComponent } from './calendar/month/calendar-month.component'
import { DateRangePickerComponent } from './date-range-picker.component'

import { DatesService } from './dates.service'

@NgModule({
  declarations: [
    CalendarComponent,
    CalendarMonthComponent,
    DateRangePickerComponent,
  ],
  exports: [
    DateRangePickerComponent,
    CommonModule,
    FormsModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    PopoverModule,
    ButtonGroupModule,
    InputNumberModule,
    SelectModule,
    CheckboxModule,
    InputTextModule,
    MessageModule,
    IconFieldModule,
    InputIconModule,
    TooltipModule,
  ],
  providers: [
    DatesService
  ]
})
export class DateRangePickerModule { }
